import { Component, h, Prop } from "@stencil/core"
import { PaymentMethodEnum, PaymentMethodEnumsObj } from "../../enums/PaymentMethodEnum"
import { validateButtonSizeEnum, validatePaymentMethodEnum } from "../../helpers/Validators"
import { SrciButtonSizeEnum } from "../../enums/SrciButtonSizeEnum"
import { srcScreenError } from "../../helpers/CommonRenders"
import clickToPayWhiteAsset from "../../assets/clickToPay/button-click-to-pay-white.svg"
import separatorWhiteAsset from "../../assets/clickToPay/button-separator-white.svg"
import mastercardAsset from "../../assets/clickToPay/mastercard.svg"
import visaWhiteAsset from "../../assets/clickToPay/visa-white.svg"
import amexAsset from "../../assets/clickToPay/amex.svg"
import discoverAsset from "../../assets/clickToPay/discover.svg"

const BUTTON_NETWORK_ASSETS: Record<string, { alt: string; src: string }> = {
  master: { alt: "Mastercard", src: mastercardAsset },
  visa: { alt: "Visa", src: visaWhiteAsset },
  amex: { alt: "American Express", src: amexAsset },
  discover: { alt: "Discover", src: discoverAsset },
}

/**
 * Component containing SRCi button.
 */
@Component({
  tag: "srci-button",
  styleUrl: "SrciButton.scss",
})
export class SrciButton {
  /**
   * Merchant site preferred locale. Format based on ISO format for language (ISO 639-1) and country code
   * (ISO 3166-1 alpha-2). The language and country should be separated using an underscore ( _ ).
   * <br /><br />
   * **Supported locale**: en_GB, sv_SE, pl_PL
   * <br /><br />
   * @default en_GB
   */
  @Prop() locale?: string

  /**
   * Indicator which Click to Pay System is supported.
   */
  @Prop() paymentMethod: PaymentMethodEnum | undefined

  /**
   * What size of SRCi button should be used.
   */
  @Prop() srciButtonSize: SrciButtonSizeEnum

  /**
   * Callback called after SRCi button click.
   */
  @Prop() srciButtonOnClick?: () => void

  private errorMessage: string[]

  componentWillLoad() {
    this.errorMessage = []

    if (this.paymentMethod && !validatePaymentMethodEnum(this.paymentMethod)) {
      this.errorMessage.push("'paymentMethod' prop is not valid")
    }

    if (!this.srciButtonSize) {
      this.errorMessage.push("'srciButtonSize' prop is not defined")
    } else if (!validateButtonSizeEnum(this.srciButtonSize)) {
      this.errorMessage.push("'srciButtonSize' prop is not valid")
    }
  }

  getButtonAssets = (): { alt: string; src: string }[] => {
    const paymentMethod = this.paymentMethod ? this.paymentMethod : PaymentMethodEnumsObj.MC
    return paymentMethod.split(",").map(method => BUTTON_NETWORK_ASSETS[method])
  }

  render() {
    if (this.errorMessage.length > 0) {
      return srcScreenError("SRC Button", this.errorMessage)
    }

    return (
      <button
        aria-label="Click to Pay cards"
        onClick={typeof this.srciButtonOnClick === "function" ? this.srciButtonOnClick : undefined}
        class={`srciButton ${this.srciButtonSize}`}>
        <span class="buttonInside">
          <img class="buttonAsset" src={clickToPayWhiteAsset} alt="Click to Pay" />
          <img
            class="buttonAsset"
            src={separatorWhiteAsset}
            alt=""
            aria-hidden="true"
          />
          {this.getButtonAssets().map(asset => (
            <img class="buttonAsset" src={asset.src} alt={asset.alt} />
          ))}
        </span>
      </button>
    )
  }
}
